// extracted by mini-css-extract-plugin
module.exports = {"fi_text":"index-module__fi_text___-ZpSz","featured_in":"index-module__featured_in___rY8nJ","img":"index-module__img___WEBzH"};